import React from 'react';
import { Switch } from 'antd';

import pedSVG from 'assets/img/trek.svg';
import cycSVG from 'assets/img/cycling.svg';
import equSVG from 'assets/img/horse-riding.svg';
import areaSVG from 'assets/img/area.svg';
import pathwaySVG from 'assets/img/pathway.svg';

const LAYERS = [{
  icon: areaSVG,
  label: 'Zones d\'incidence',
  value: 'hors_chemins',
}, {
  icon: pathwaySVG,
  label: 'Tous les chemins',
  value: 'chemins',
}, {
  icon: pedSVG,
  label: 'Balisages pédestres',
  value: 'chemins_BAL_PED',
}, {
  icon: cycSVG,
  label: 'Vélos autorisés',
  value: 'chemins_AUT_CYC',
}, {
  icon: cycSVG,
  label: 'Balisage vélos',
  value: 'chemins_BAL_CYC',
}, {
  icon: equSVG,
  label: 'Chevaux autorisés',
  value: 'chemins_AUT_EQU',
}, {
  icon: equSVG,
  label: 'Balisage équestre',
  value: 'chemins_BAL_EQU',
}];

export class LocationForm extends React.Component {
  onChange = value => checked => {
    const { onChange, onValid, control: { filters: prevFilters = [] } } = this.props;
    const filters = new Set([...prevFilters]);
    filters[checked ? 'add' : 'delete'](value);
    onChange({ filters: [...filters] });
    onValid(true);
  }

  render () {
    const { control: { filters = [] } } = this.props;
    const { onChange } = this;

    return (
      <ul className="location-form">
        {LAYERS.map(({ icon, label, value }) => (
          <li
            key={value}
            className="location-form__item location-form-item"
          >
            <label>
              <img
                className="location-form-item__icon"
                src={icon}
                alt={label}
              />
              <span className="location-form-item__label">{label}</span>
              <Switch
                defaultChecked={filters.includes(value)}
                onChange={onChange(value)}
              />
            </label>
          </li>
        ))}
      </ul>
    );
  }
}

export default LocationForm;



// WEBPACK FOOTER //
// ./src/components/Admin/ActivitiesManagement/ActivityEdit/Control/LocationForm.js